<template>
  <div class="background">
    <div class="content container">
      <div class="row" v-anime="{opacity: 1, loop: false, duration: 5000 }">
        <div class="col align-self-center">
          <md-card class="align-self-center">
            <md-card-header>
              <div class="md-title">
                <font-awesome-icon icon="user-tie" size="3x" />
              </div>
            </md-card-header>
            <md-card-content class="mt-4">
              <li>
                <p>Consulting</p>
                <p>Project Leadership</p>
                <p>Requirements Engineering</p>
              </li>
            </md-card-content>
          </md-card>
        </div>
        <div class="col align-self-center">
          <md-card class="align-self-center">
            <md-card-header>
              <div class="md-title">
                <font-awesome-icon icon="user-astronaut" size="3x" />
              </div>
            </md-card-header>
            <md-card-content class="mt-4">
              <li>
                <p>Wireframing</p>
                <p>Prototyping</p>
                <p>Bootstrapping</p>
              </li>
            </md-card-content>
          </md-card>
        </div>
        <div class="col align-self-center">
          <md-card class="align-self-center">
            <md-card-header>
              <div class="md-title">
                <font-awesome-icon icon="user-ninja" size="3x" />
              </div>
            </md-card-header>

            <md-card-content class="mt-4">
              <li>
                <p>Hybrid Developer</p>
                <p>Frontend Developer</p>
                <p>Fullstack Developer</p>
              </li>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.font-awesome-icon {
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgb(255, 255, 255)),
    to(rgba(17, 40, 241, 0.952))
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.md-card {
  text-align: center;
  min-width: 210px;
  max-width: 210px;
  height: 300px;
  margin-bottom: 20px;
  margin-left:auto;
  margin-right:auto;
  vertical-align: center;
  background: #fff;
}

.content {
  padding-top: 100px;
  //padding-left: 100px;
  overflow-y: scroll;
}
::-webkit-scrollbar {
    display: none;
}
.background {
  background-color: transparent;
}

li {
  list-style-type: none;

}
</style>

<script>
export default {
  name: "Services"
};
</script>
